module.exports = __webpack_public_path__ + "static/media/spinner.695888b4.gif";